module.exports = __webpack_public_path__ + "media/flags/lb-f2e6a2e1.svg";